export default {
  getBookName(bookId) {
    return ShasBooks[bookId].bookName;
  },
  getFullName(bookId, page) {
    let name = "";
    let book = ShasBooks[bookId];
    if (book.firstPage > page && book.bookid == 176566)
      book = ShasBooks[bookId + "0000"];

    name = book.bookName;

    let add = 0;
    if (book.firstLabelPage != undefined) add = book.firstLabelPage;
    if (page % 2 == 0) {
      name += ` ${pagesDic(book.firstPage + add, page)}`;
      name += ".";
    } else {
      page -= 1;
      name += ` ${pagesDic(book.firstPage + add, page)}`;
      name += ":";
    }

    return name;
  },
  getFullNameObj(bookId, page) {
    let name = "";
    let book = ShasBooks[bookId];
    if (book.firstPage > page && book.bookid == 176566)
      book = ShasBooks[bookId + "0000"];
    name = book.bookName;
    let bookPage = "";
    if (book.firstLabelPage != undefined) add = book.firstLabelPage;
    if (page % 2 == 0) {
      bookPage += ` ${pagesDic(book.firstPage, page)}`;
      bookPage += ".";
    } else {
      page -= 1;
      bookPage += ` ${pagesDic(book.firstPage, page)}`;
      bookPage += ":";
    }

    return { bookName: name, bookPage };
  },
};
export function getBookPages(start, end) {
  let pages = [];
  for (let i = start; i <= end + start; i += 2) {
    pages.push({
      title: pagesDic(start, i),
      number: i,
    });
  }
  return pages;
}
export let letters = [
  "ב",
  "ג",
  "ד",
  "ה",
  "ו",
  "ז",
  "ח",
  "ט",
  "י",
  "יא",
  "יב",
  "יג",
  "יד",
  "טו",
  "טז",
  "יז",
  "יח",
  "יט",
  "כ",
  "כא",
  "כב",
  "כג",
  "כד",
  "כה",
  "כו",
  "כז",
  "כח",
  "כט",
  "ל",
  "לא",
  "לב",
  "לג",
  "לד",
  "לה",
  "לו",
  "לז",
  "לח",
  "לט",
  "מ",
  "מא",
  "מב",
  "מג",
  "מד",
  "מה",
  "מו",
  "מז",
  "מח",
  "מט",
  "נ",
  "נא",
  "נב",
  "נג",
  "נד",
  "נה",
  "נו",
  "נז",
  "נח",
  "נט",
  "ס",
  "סא",
  "סב",
  "סג",
  "סד",
  "סה",
  "סו",
  "סז",
  "סח",
  "סט",
  "ע",
  "עא",
  "עב",
  "עג",
  "עד",
  "עה",
  "עו",
  "עז",
  "עח",
  "עט",
  "פ",
  "פא",
  "פב",
  "פג",
  "פד",
  "פה",
  "פו",
  "פז",
  "פח",
  "פט",
  "צ",
  "צא",
  "צב",
  "צג",
  "צד",
  "צה",
  "צו",
  "צז",
  "צח",
  "צט",
  "ק",
  "קא",
  "קב",
  "קג",
  "קד",
  "קה",
  "קו",
  "קז",
  "קח",
  "קט",
  "קי",
  "קיא",
  "קיב",
  "קיג",
  "קיד",
  "קטו",
  "קטז",
  "קיז",
  "קיח",
  "קיט",
  "קכ",
  "קכא",
  "קכב",
  "קכג",
  "קכד",
  "קכה",
  "קכו",
  "קכז",
  "קכח",
  "קכט",
  "קל",
  "קלא",
  "קלב",
  "קלג",
  "קלד",
  "קלה",
  "קלו",
  "קלז",
  "קלח",
  "קלט",
  "קמ",
  "קמא",
  "קמב",
  "קמג",
  "קמד",
  "קמה",
  "קמו",
  "קמז",
  "קמח",
  "קמט",
  "קנ",
  "קנא",
  "קנב",
  "קנג",
  "קנד",
  "קנה",
  "קנו",
  "קנז",
  "קנח",
  "קנט",
  "קס",
  "קסא",
  "קסב",
  "קסג",
  "קסד",
  "קסה",
  "קסו",
  "קסז",
  "קסח",
  "קסט",
  "קע",
  "קעא",
  "קעב",
  "קעג",
  "קעד",
  "קעה",
  "קעו",
  "קעז",
  "קעח",
  "קעט",
  "קפ",
  "קפא",
  "קפב",
];
export function pagesDic(first, num) {
  if (first > 20) return letters[parseInt((num - 6) / 2)];
  else return letters[parseInt((num - first) / 2)];
}

export const ShasBooks = {
  173917: {
    bookName: "ברכות",
    firstPage: 10,
    count: 125,
    bookid: 173917,
    o: 0,
    done: true,
  },
  173919: {
    bookName: "שבת",
    firstPage: 8,
    count: 312,
    bookid: 173919,
    o: 1,
    done: true,
  },
  173920: {
    bookName: "עירובין",
    firstPage: 8,
    count: 207,
    bookid: 173920,
    o: 2,
    done: true,
  },
  173921: {
    bookName: "פסחים",
    firstPage: 8,
    count: 240,
    bookid: 173921,
    o: 3,
    done: true,
  },
  173922: {
    bookName: "ראש השנה",
    firstPage: 8,
    count: 67,
    bookid: 173922,
    o: 4,
    done: true,
  },
  176549: {
    bookName: "יומא",
    firstPage: 4,
    count: 173,
    bookid: 176549,
    o: 5,
    done: true,
  },
  176550: {
    bookName: "סוכה",
    firstPage: 4,
    count: 110,
    bookid: 176550,
    done: true,
    o: 6,
  },
  173923: {
    bookName: "ביצה",
    firstPage: 8,
    count: 78,
    bookid: 173923,
    done: true,
    o: 7,
  },
  176551: {
    bookName: "תענית",
    firstPage: 4,
    count: 60,
    bookid: 176551,
    done: true,
    o: 8,
  },
  176552: {
    bookName: "מגילה",
    firstPage: 4,
    count: 61,
    bookid: 176552,
    done: true,
    o: 9,
  },
  176553: {
    bookName: "מועד קטן",
    firstPage: 4,
    count: 75,
    bookid: 176553,
    done: true,
    o: 10,
  },
  176554: {
    bookName: "חגיגה",
    firstPage: 4,
    count: 51,
    bookid: 176554,
    done: true,
    o: 11,
  },
  173924: {
    bookName: "יבמות",
    firstPage: 8,
    count: 242,
    bookid: 173924,
    done: true,
    o: 12,
  },
  173925: {
    bookName: "כתובות",
    firstPage: 8,
    count: 222,
    bookid: 173925,
    done: true,
    o: 13,
  },
  173926: {
    bookName: "נדרים",
    firstPage: 8,
    count: 180,
    bookid: 173926,
    done: true,
    o: 14,
  },
  176555: {
    bookName: "נזיר",
    firstPage: 4,
    count: 130,
    bookid: 176555,
    done: true,
    o: 15,
  },
  176556: {
    bookName: "סוטה",
    firstPage: 4,
    count: 96,
    bookid: 176556,
    done: true,
    o: 16,
  },
  173927: {
    bookName: "גיטין",
    firstPage: 8,
    count: 178,
    bookid: 173927,
    done: true,
    o: 17,
  },
  173928: {
    bookName: "קידושין",
    firstPage: 8,
    count: 162,
    bookid: 173928,
    // showPop: "nismat-1.png",
    done: true,
    o: 18,
  },
  173929: {
    bookName: "בבא קמא",
    firstPage: 8,
    count: 236,
    bookid: 173929,
    done: true,
    o: 19,
  },
  173930: {
    bookName: "בבא מציעא",
    firstPage: 8,
    count: 235,
    bookid: 173930,
    done: true,
    o: 20,
  },
  173931: {
    bookName: "בבא בתרא",
    firstPage: 8,
    count: 350,
    bookid: 173931,
    done: true,
    o: 21,
  },
  173932: {
    bookName: "סנהדרין",
    firstPage: 8,
    count: 224,
    bookid: 173932,
    done: true,
    o: 22,
  },
  176557: {
    bookName: "מכות",
    firstPage: 4,
    count: 46,
    bookid: 176557,
    done: true,
    o: 23,
  },
  176558: {
    bookName: "שבועות",
    firstPage: 4,
    count: 96,
    bookid: 176558,
    done: true,
    o: 24,
  },
  173933: {
    bookName: "עבודה זרה",
    firstPage: 8,
    count: 150,
    bookid: 173933,
    done: true,
    o: 25,
  },
  176559: {
    bookName: "הוריות",
    firstPage: 4,
    count: 26,
    bookid: 176559,
    done: true,
    o: 26,
  },
  173934: {
    bookName: "זבחים",
    firstPage: 8,
    count: 238,
    bookid: 173934,
    done: true,
    o: 27,
  },
  176562: {
    bookName: "מנחות",
    firstPage: 4,
    count: 217,
    bookid: 176562,
    done: true,
    o: 28,
  },
  173935: {
    bookName: "חולין",
    firstPage: 8,
    count: 281,
    bookid: 173935,
    done: true,
    o: 29,
  },
  173936: {
    bookName: "בכורות",
    firstPage: 8,
    count: 119,
    bookid: 173936,
    done: true,
    o: 30,
  },
  176563: {
    bookName: "ערכין",
    firstPage: 4,
    count: 65,
    bookid: 176563,
    done: true,
    o: 31,
  },
  176564: {
    bookName: "תמורה",
    firstPage: 4,
    count: 65,
    bookid: 176564,
    done: true,
    o: 32,
  },
  176565: {
    bookName: "כריתות",
    firstPage: 4,
    count: 54,
    bookid: 176565,
    done: true,
    o: 33,
  },
  1765660000: {
    bookName: "מעילה",
    done: true,
    firstPage: 4,
    count: 41,
    fpath: true,
    bookid: 176566,
    o: 34,
  },

  176566: {
    bookName: "תמיד",
    done: true,
    firstPage: 52,
    // count: 64,
    count: 32,
    firstLabelPage: -46,
    bookid: 176566,
    o: 35,
  },
  173937: {
    bookName: "נדה",
    firstPage: 8,
    count: 143,
    bookid: 173937,
    done: true,
    o: 36,
  },
  142010: {
    bookName: "מדע",
    firstPage: 15,
    count: 119,
    bookid: 142010,
    o: 0,
    done: true,
    yesod: "rambam",
  },
  142009: {
    bookName: "אהבה",
    firstPage: 1,
    count: 147,
    bookid: 142009,
    o: 1,
    done: true,
    yesod: "rambam",
  },
  142011: {
    bookName: "זמנים",
    firstPage: 3,
    count: 371,
    bookid: 142011,
    o: 2,
    done: true,
    yesod: "rambam",
  },
  142012: {
    bookName: "נשים",
    firstPage: 1,
    count: 309,
    bookid: 142012,
    o: 3,
    done: true,
    yesod: "rambam",
  },
  142013: {
    bookName: "קדושה",
    firstPage: 1,
    count: 302,
    bookid: 142013,
    o: 4,
    done: true,
    yesod: "rambam",
  },
  142014: {
    bookName: "הפלאה",
    firstPage: 1,
    count: 206,
    bookid: 142014,
    o: 5,
    done: true,
    yesod: "rambam",
  },
  142015: {
    bookName: "זרעים",
    firstPage: 1,
    count: 253,
    bookid: 142015,
    done: true,
    o: 6,
    yesod: "rambam",
  },
  142016: {
    bookName: "עבודה",
    firstPage: 1,
    count: 240,
    bookid: 142016,
    done: true,
    o: 7,
    yesod: "rambam",
  },
  142017: {
    bookName: "קרבנות",
    firstPage: 1,
    count: 98,
    bookid: 142017,
    done: true,
    o: 8,
    yesod: "rambam",
  },
  142018: {
    bookName: "טהרה",
    firstPage: 1,
    count: 232,
    bookid: 142018,
    done: true,
    o: 9,
    yesod: "rambam",
  },
  142019: {
    bookName: "נזיקין",
    firstPage: 2,
    count: 136,
    bookid: 142019,
    done: true,
    o: 10,
    yesod: "rambam",
  },
  142020: {
    bookName: "קנין",
    firstPage: 2,
    count: 214,
    bookid: 142020,
    done: true,
    o: 11,
    yesod: "rambam",
  },
  142021: {
    bookName: "משפטים",
    firstPage: 1,
    count: 234,
    bookid: 142021,
    done: true,
    o: 12,
    yesod: "rambam",
  },
  142022: {
    bookName: "שופטים",
    firstPage: 1,
    count: 208,
    bookid: 142022,
    done: true,
    o: 13,
    yesod: "rambam",
  },
};
